import { render, staticRenderFns } from "./confirm-block-modal.vue?vue&type=template&id=3b280f37&"
import script from "./confirm-block-modal.vue?vue&type=script&lang=js&"
export * from "./confirm-block-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports